export default __webpack_public_path__ + "static/media/4.17d4f32c.svg";